import React from 'react';
import Button from 'components/Button';

type ActionBarProps = {
  onNext: () => void;
  onBack: () => void;
  loading?: boolean;
  className?: string;
  nextTestId?: string;
  nextText?: React.ReactNode;
  backText?: React.ReactNode;
};

export const ActionBar: React.FC<ActionBarProps> = ({
  onNext,
  onBack,
  loading,
  nextText = 'Continue',
  backText = 'Back',
  className = '',
  nextTestId,
}) => (
  <div className={`flex justify-center items-center flex-col ${className}`}>
    <Button
      text={nextText}
      variant='tertiary'
      loading={loading}
      data-testid={nextTestId}
      iconPosition='right'
      icon='arrow_right'
      style={{
        marginTop: 30,
        marginBottom: 16,
        background: '#000',
        borderColor: '#000',
      }}
      onClick={() => {
        onNext();
      }}
    />
    <div
      className='text-black cursor-pointer'
      onClick={() => {
        onBack();
      }}
    >
      {backText}
    </div>
  </div>
);
